"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapGetOrderToReviewResponseToEntity = void 0;
function mapGetOrderToReviewResponseToEntity(response) {
    if (!response.order || !response.reseller) {
        return null;
    }
    return {
        order: {
            id: response.order.id,
            businessUnit: response.order.businessUnit,
            deliveryStatus: response.order.deliveryStatus,
            createdAt: new Date(response.order.createdAt),
        },
        reseller: {
            name: response.reseller.name,
            store: {
                name: response.reseller.store.name,
                logo: response.reseller.store.logo,
            },
        },
    };
}
exports.mapGetOrderToReviewResponseToEntity = mapGetOrderToReviewResponseToEntity;
